import * as _ from "lodash";
import * as React from "react";
import LoadObject from "../../load_objects/LoadObject";
import { Fixture } from "../records/Fixture";
import { CompetitionFixturesView, DisplayedFixture} from "./CompetitionFixturesView";

export interface IFixturesListViewProps {
  fixtures: Array<Fixture>;
  fixtureLoader: LoadObject<Fixture>;
}

export interface IFixturesListViewState {
  displayedFixtures: DisplayedFixture[];
}

export class FixturesListView extends React.Component<IFixturesListViewProps, IFixturesListViewState> {
  constructor(props: any) {
    super(props);
    this.state = this.getInitialState();
  }

  private getInitialState(): IFixturesListViewState {
    return { displayedFixtures: [] };
  }

  public componentDidUpdate(prevProps, prevState) {
    if(prevProps === this.props) {
        return;
    }
    const displayedFixtures = [] as DisplayedFixture[];
    this.props.fixtures.forEach((fixture) => {
        const previousDisplayed = prevState?.displayedFixtures[fixture.id]?.displayed || false;
        displayedFixtures[fixture.id] = { fixture: fixture, displayed: previousDisplayed };
      }
    );
    this.setState({displayedFixtures: displayedFixtures});
  }

  private onFixtureClicked(id: number, state?: boolean) {
    const fixture: DisplayedFixture = this.state.displayedFixtures[id];
    fixture.displayed = state || !fixture.displayed;
    if(fixture.fixture.status.toLowerCase() === "started") {
        this.state.displayedFixtures
            .filter(otherFixture => otherFixture.fixture.status.toLowerCase() === "started" && otherFixture.fixture.id !== fixture.fixture.id)
            .forEach(otherLiveFixture => {
                otherLiveFixture.displayed = false;
            });
    }
    this.setState(this.state);
  }

  private getLiveScoreboardId() : number {
    return this.state.displayedFixtures.find(fixture => fixture && fixture.displayed && fixture.fixture.status === "Started" && fixture.displayed)?.fixture?.id!;
  }

  public render() {
    const fixtureLoader = this.props.fixtureLoader;

    if (!fixtureLoader.getValue()) {
      return (
        <div>Loading fixtures...</div>
      );
    } else if (fixtureLoader.hasError()) {
        return (
        <div>Error getting fixtures</div>
        );
    } else if (this.state.displayedFixtures.length == 0) {
      return (
        <div>No fixtures match the current selection.</div> 
      );
    }
    const compFixtures = _(this.state.displayedFixtures)
        .filter(displayedFixture => displayedFixture !== undefined)
        .sortBy(displayedFixture => displayedFixture.fixture.scheduledStartTime)
        .groupBy(displayedFixture => displayedFixture.fixture.competition.name)
        .map((fixtures, compName) => {
            return (
            <CompetitionFixturesView
                key={"comp_" + compName}
                competitionName={compName}
                fixtures={fixtures}
                fixtureClicked={(id: number, state?: boolean) => this.onFixtureClicked(id, state)}
                getLiveScoreboardId={() => this.getLiveScoreboardId()}
            />
            );
        })
        .value();

    return <div>{compFixtures}</div>;
  }
}
